import React, { useEffect } from "react";
import { toast } from "react-toastify";
import NewVersionToast from "../components/NewVersionToast";
import { checkAppVersion } from "../common/common.version.compare";

const useWindowFocus = () => {
	const handleFocus = async () => {
		const isNewer = await checkAppVersion();
		if (isNewer) {
			toast(<NewVersionToast />, {
				toastId: "new-version-toast",
				autoClose: false,
				position: "top-right",
			});
		}
	};

	useEffect(() => {
		handleFocus();

		window.addEventListener("focus", handleFocus);

		return () => {
			window.removeEventListener("focus", handleFocus);
		};
	}, []);
};

export default useWindowFocus;
